// Helpers de horario para la UI (los eventos gastronómicos cruzan medianoche).
// Espeja la lógica de horasT() de src/worker/calculo.ts, pero para el front:
// el cálculo de plata sigue 100% en el server; esto es solo para mostrar en vivo.

/** "HH:mm" → minutos desde medianoche. */
function aMinutos(hhmm: string): number {
  const [h, m] = hhmm.split(':').map((x) => parseInt(x, 10));
  return (h || 0) * 60 + (m || 0);
}

/** ¿El intervalo termina al día siguiente? (fin antes que inicio). */
export function cruzaMedianoche(inicio: string, fin: string): boolean {
  if (!inicio || !fin) return false;
  return aMinutos(fin) < aMinutos(inicio);
}

/** Horas entre dos "HH:mm", contando el cruce de medianoche. Ej: 20:00→02:30 = 6.5 */
export function horasEntreHHmm(inicio: string, fin: string): number {
  if (!inicio || !fin) return 0;
  const i = aMinutos(inicio);
  let f = aMinutos(fin);
  if (f < i) f += 24 * 60; // cruza medianoche
  return (f - i) / 60;
}

/** Rango legible. Ej: "20:00–02:30". Sin sufijo "(+1 día)": Fernando lo sacó
 *  de todas las vistas (14/07/2026) — en el rubro se sobreentiende que un fin
 *  menor que el inicio es de madrugada. */
export function formatoRango(inicio: string, fin: string): string {
  if (!inicio || !fin) return '';
  return `${inicio}–${fin}`;
}
